import * as actions from './doc.actions';
import { EntityState, createEntityAdapter, Update } from '@ngrx/entity';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DocModel } from '@smarttask-common/src/lib/models/Record/Doc/Core/DocModel';

export const docAdapter = createEntityAdapter<DocModel>({
    selectId: (x) => x.record_id,
});
export interface DocState extends EntityState<DocModel> {
    selected_record_id: string;
}

export const initialState: DocState = docAdapter.getInitialState({
    selected_record_id: undefined,
});

export function DocReducers(state: DocState = initialState, action: actions.DocActions) {
    switch (action.type) {
        case actions.DocActionTypes.UPDATE_SELECTED_ID:
            state = { ...state, selected_record_id: action.selected_record_id };
            return state;

        case actions.DocActionTypes.ADD_DOC:
            return docAdapter.addOne(action.doc, { ...state, selected_record_id: state.selected_record_id });

        case actions.DocActionTypes.ADD_DOCS:
            return docAdapter.addMany(action.docs, { ...state, selected_record_id: state.selected_record_id });

        case actions.DocActionTypes.UPSERT_DOC:
            return docAdapter.upsertOne(action.doc, { ...state, selected_record_id: state.selected_record_id });

        case actions.DocActionTypes.UPSERT_DOCS:
            return docAdapter.upsertMany(action.docs, { ...state, selected_record_id: state.selected_record_id });

        case actions.DocActionTypes.UPDATE_DOC:
            return docAdapter.updateOne(
                {
                    id: action.id,
                    changes: action.changes,
                },
                { ...state, selected_record_id: state.selected_record_id },
            );

        case actions.DocActionTypes.UPDATE_DOCS:
            return docAdapter.updateMany(action.updates, { ...state, selected_record_id: state.selected_record_id });

        case actions.DocActionTypes.DELETE_DOC:
            return docAdapter.removeOne(action.id, { ...state, selected_record_id: state.selected_record_id });

        case actions.DocActionTypes.DELETE_DOCS:
            return docAdapter.removeMany(action.ids, { ...state, selected_record_id: state.selected_record_id });

        case actions.DocActionTypes.DELETE_STATE:
            // state?.selected_record_id = undefined;
            return docAdapter.removeAll(state);

        default:
            return state;
    }
}

export const getDocState = createFeatureSelector<DocState>('doc');

const getSelectedDocIdState = (state: DocState) => {
    return state.selected_record_id;
};
export const getSelectedDocId = createSelector(getDocState, getSelectedDocIdState);

export const getSelectedDoc = createSelector(getDocState, (state: DocState) => {
    if (state.selected_record_id == undefined) {
        return undefined;
    }
    return state.entities[state.selected_record_id];
});

export const { selectIds, selectEntities, selectAll, selectTotal } = docAdapter.getSelectors(getDocState);
